function getCroppedImg(file, crop = false, maxSize = 400) {
  return new Promise((resolve, reject) => {
    const img = new Image();

    img.onload = () => {
      if (!crop) {
        resolve(file);
        return;
      }

      const sourceWidth = img.width;
      const sourceHeight = img.height;

      // Calculate the dimensions for the initial square crop
      const limit = Math.min(sourceWidth, sourceHeight);
      const sourceX = (sourceWidth - limit) / 2;
      const sourceY = (sourceHeight - limit) / 2;

      let targetWidth = limit;
      let targetHeight = limit;

      // Check if resizing of the cropped square is needed
      if (limit > maxSize) {
        targetWidth = maxSize;
        targetHeight = maxSize;
      }

      const canvas = document.createElement('canvas');
      canvas.width = targetWidth;
      canvas.height = targetHeight;
      const ctx = canvas.getContext('2d');

      ctx.drawImage(img, sourceX, sourceY, limit, limit, 0, 0, targetWidth, targetHeight);

      canvas.toBlob(
        (blob) => {
          if (blob) {
            resolve(blob);
          } else {
            reject(new Error('Failed to create Blob from canvas.'));
          }
        },
        'image/png'
      );
    };

    img.onerror = () => {
      reject(new Error('Failed to load the image.'));
    };

    img.src = URL.createObjectURL(file);
  });
}

export default getCroppedImg;